
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"20.944"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M20.993 3.183c-.046.178-.079.356-.132.534a3.081 3.081 0 01-.784 1.252q-4.843 4.843-9.693 9.686a1.419 1.419 0 01-.507.323c-1.417.488-2.84.949-4.263 1.43a.83.83 0 01-.784-.066.779.779 0 01-.25-.936c.369-1.107.778-2.2 1.094-3.321a4.9 4.9 0 011.371-2.214c2.965-2.919 5.9-5.864 8.83-8.81a3.21 3.21 0 011.9-1.041c.013 0 .02-.013.033-.02h.659a.26.26 0 00.092.033 2.82 2.82 0 012.306 1.957 5.537 5.537 0 01.138.547c-.01.211-.01.428-.01.646z"}}),_c('path',{staticClass:"a",attrs:{"d":"M.013 11.215V3.776a2.233 2.233 0 011.845-2.254 2.635 2.635 0 01.507-.04h8.751c.514 0 .83.244.87.672a.729.729 0 01-.7.817c-.079.007-.165 0-.244 0H2.418a1.33 1.33 0 00-.362.04.71.71 0 00-.534.626 3.332 3.332 0 00-.013.264v14.628a2.04 2.04 0 00.013.283.721.721 0 00.633.626 1.767 1.767 0 00.264.013H15.57c.072 0 .152 0 .224-.007a.721.721 0 00.685-.712c.013-.283.007-.573.007-.863v-6.5a1.511 1.511 0 01.053-.422.738.738 0 011.41.053 1.187 1.187 0 01.033.3c0 2.438.007 4.876 0 7.314a2.246 2.246 0 01-1.746 2.26 2.333 2.333 0 01-.567.059H2.313A2.24 2.24 0 010 18.628c.013-2.451.013-4.935.013-7.413z"}})])
          )
        }
      }
    